export { default as get } from './get';



// WEBPACK FOOTER //
// ./src/services/api/admin/history/index.ts